import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import dayjs from 'dayjs';
import {Table, Button, Select, message} from 'antd';
import {useHistory} from 'react-router-dom';

import {selectStatusFilter, selectStatusOptions} from './utils';

import {
    fetchUserInfo
} from '../../actions/attestAction';
import {
    fetchDataReviewList
} from '../../actions/dataReview';

import './dataReviewList.less';

interface DataReviewListProps {
    fetchUserInfo: () => void;
    fetchDataReviewList: (param: any) => Promise<any>;
}
const SelectOption = Select.Option;
export function DataReviewList(props: DataReviewListProps) {
    const [dataList, setDataList] = useState([] as any);
    const [tableLoading, setTableLoading] = useState(false);
    const [selectType, setSelectType] = useState('全部');
    const [selectStatus, setSelectStatus] = useState('-1');
    const [pageCurrent, setPageCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pageTotal, setPageTotal] = useState(0);
    const history = useHistory();
    useEffect(() => {
        fetDataList();
    }, []);
    const fetDataList = (initialParam?: any) => {
        const param = {
            page: initialParam?.page || pageCurrent,
            size: initialParam?.size || pageSize,
            import_name: '全部',
            data_type: initialParam?.selectType || selectType,
            status: initialParam?.selectStatus || selectStatus,
        };
        setTableLoading(true);
        props.fetchDataReviewList(param)
            .then(res => {
                if (res && res.code === 200) {
                    setPageTotal(res.data?.total || 0);
                    setDataList(res.data?.list || []);
                    setTableLoading(false);
                } else {
                    message.error(res.message || '获取数据失败');
                    setTableLoading(false);
                }
            })
            .catch(() => {
                message.error('获取数据失败');
                setTableLoading(false);
            });
    };
    const getColumns = () => {
        return [{
            title: '批次号',
            dataIndex: 'batch_number',
            key: 'batch_number',
            width: 200
        }, {
            title: '创建时间',
            dataIndex: 'create_time',
            key: 'create_time',
            render: (text: string) => {
                return dayjs(text).format('YYYY-MM-DD HH:mm:ss');
            }
        }, {
            title: '创建人',
            dataIndex: 'operator',
            key: 'operator',
        }, {
            title: '名称',
            dataIndex: 'import_name',
            key: 'import_name',
        }, {
            title: '出卡类型',
            dataIndex: 'card_type',
            key: 'card_type',
        }, {
            title: '数据类型',
            dataIndex: 'data_type',
            key: 'data_type'
        }, {
            title: '抓取总量',
            dataIndex: 'grab_total',
            key: 'grab_total'
        }, {
            title: '上线总量',
            dataIndex: 'online_total',
            key: 'online_total'
        }, {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            render: (text) => {
                return selectStatusFilter(text);
            }
        }, {
            title: '操作',
            dataIndex: 'status',
            key: 'action',
            render: (_, item) => {
                if (item.status === 0 || item.status === 1 || item.status === 2) {
                    const cardType = item.card_type.indexOf('组卡') !== -1 ? 'group' : 'single';
                    return (
                        <Button type="link" onClick={() => {
                            history.push(`/data_review/${item.type}/${item.id}/${cardType}`);
                        }}>
                            查看
                        </Button>
                    );
                }
            }
        }];
    };
    const onPageChange = (page, size) => {
        if (page !== pageCurrent) {
            setPageCurrent(page);
            fetDataList({
                page,
            });
        }
        if (size !== pageSize) {
            setPageSize(1);
            fetDataList({
                page: 1,
                limit: pageSize
            });
        }
    };
    const selectChange = (value: string, type: string) => {
        if (type === 'selectType') {
            setSelectType(value);
            setPageCurrent(1);
            fetDataList({selectType: value || '全部', page: 1});
        } else if (type === 'selectStatus') {
            setSelectStatus(value);
            setPageCurrent(1);
            fetDataList({selectStatus: value || '全部', page: 1});
        }
    };

    return <div className="data-review-list">
        <div className="table-wrapper">
            <div className="search-wrapper">
                <div className="search-item">
                    <span>数据类型：</span>
                    <Select
                        value={selectType}
                        onChange={e => selectChange(e, 'selectType')}
                    >
                        <SelectOption value="全部">全部</SelectOption>
                        <SelectOption value="公司类">公司类</SelectOption>
                        <SelectOption value="民生类">民生类</SelectOption>
                        <SelectOption value="民生类2">民生类2</SelectOption>
                    </Select>
                </div>
                <div className="search-item">
                    <span>状态：</span>
                    <Select
                        value={selectStatus}
                        options={selectStatusOptions}
                        onChange={e => selectChange(e, 'selectStatus')}
                    >
                    </Select>
                </div>
            </div>

            <Table
                dataSource={dataList}
                columns={getColumns()}
                rowKey="batch_number"
                loading={tableLoading}
                pagination={{
                    total: pageTotal,
                    pageSize: pageSize,
                    current: pageCurrent,
                    onChange: onPageChange,
                    position: ['bottomCenter']
                }}
            />

        </div>
    </div>;
}

function mapStateToProps(state) {
    return {
        appealData: state.appealReducer
    };
}
function mapDispatchToProps(dispatch) {
    return {
        fetchUserInfo: () => fetchUserInfo(dispatch),
        fetchDataReviewList: (param) => fetchDataReviewList(dispatch, param),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DataReviewList as any));
